const routes = [
    { path: '/', label: 'Home' },
    { path: '/seguro-salud', label: 'Seguro de Salud' },
    { path: '/seguro-hogar', label: 'Seguro de Hogar' },
    { path: '/seguro-vida', label: 'Seguro de Vida' },
    { path: '/seguro-vehicular', label: 'Seguro Vehicular' },
    { path: '/otros-seguros', label: 'Otros Seguros' },
  ]

export default routes